import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  topBar: { id: 'modelViewer.topBar', defaultMessage: 'View tools' },
  shading: { id: 'modelViewer.shading', defaultMessage: 'Shading' },
  shadingEdged: { id: 'modelViewer.shading.edged', defaultMessage: 'Edged faces' },
  shadingShaded: { id: 'modelViewer.shading.shaded', defaultMessage: 'Shaded' },
  shadingGhosted: { id: 'modelViewer.shading.ghosted', defaultMessage: 'Ghosted' },
  shadingWireframe: { id: 'modelViewer.shading.wireframe', defaultMessage: 'Wireframe' },
  selectBodies: { id: 'modelViewer.select.bodies', defaultMessage: 'Select bodies' },
  selectVertices: { id: 'modelViewer.select.vertices', defaultMessage: 'Select vertices' },
  loadModelFirst: { id: 'modelViewer.loadModelFirst', defaultMessage: 'Load a model first' },
  section: { id: 'modelViewer.section', defaultMessage: 'Section' },
  sectionFlip: { id: 'modelViewer.section.flip', defaultMessage: 'Flip section' },
  sectionExit: { id: 'modelViewer.section.exit', defaultMessage: 'Exit section' },
  sectionResetRotation: { id: 'modelViewer.section.resetRotation', defaultMessage: 'Reset rotation' },
  sectionOffset: { id: 'modelViewer.section.offset', defaultMessage: 'Offset' },
  sectionRotate: { id: 'modelViewer.section.rotate', defaultMessage: 'Rotate about {axis}' },
  tools: { id: 'modelViewer.tools', defaultMessage: 'Viewport tools' },
  measure: { id: 'modelViewer.measure', defaultMessage: 'Measure distance' },
  measureTooDense: {
    id: 'modelViewer.measure.tooDense',
    defaultMessage: 'Measure is unavailable on a model this detailed',
  },
  dimensions: { id: 'modelViewer.dimensions', defaultMessage: 'Dimensions' },
  environment: { id: 'modelViewer.environment', defaultMessage: 'Scene' },
  centre: { id: 'modelViewer.environment.centre', defaultMessage: 'Centre on origin' },
  sit: { id: 'modelViewer.environment.sit', defaultMessage: 'Sit on grid' },
  shadows: { id: 'modelViewer.environment.shadows', defaultMessage: 'Shadows' },
  occlusion: { id: 'modelViewer.environment.occlusion', defaultMessage: 'Ambient occlusion' },
  gridToggle: { id: 'modelViewer.environment.grid', defaultMessage: 'Grid' },
  underLight: { id: 'modelViewer.environment.underLight', defaultMessage: 'Under-light' },
  underLightSettings: { id: 'modelViewer.underLight.settings', defaultMessage: 'Under-light settings' },
  underLightColour: { id: 'modelViewer.underLight.colour', defaultMessage: 'Colour' },
  underLightIntensity: { id: 'modelViewer.underLight.intensity', defaultMessage: 'Intensity' },
  underLightAround: { id: 'modelViewer.underLight.around', defaultMessage: 'Around' },
  underLightTilt: { id: 'modelViewer.underLight.tilt', defaultMessage: 'Tilt' },
  platform: { id: 'modelViewer.environment.platform', defaultMessage: 'Build platform' },
  backgroundLoad: { id: 'modelViewer.background.load', defaultMessage: 'Load a background image' },
  backgroundRemove: { id: 'modelViewer.background.remove', defaultMessage: 'Remove background image' },
  backgroundUnsupported: {
    id: 'modelViewer.background.unsupported',
    defaultMessage: 'Use a PNG, JPG or WebP image under 20 MB',
  },
  backgroundUnreadable: {
    id: 'modelViewer.background.unreadable',
    defaultMessage: 'That image could not be opened',
  },
  fitView: { id: 'modelViewer.fitView', defaultMessage: 'Fit view' },
  grid: { id: 'modelViewer.grid', defaultMessage: 'Grid {spacing}' },
  gridMenu: { id: 'modelViewer.grid.menu', defaultMessage: 'Grid spacing' },
  gridFollow: { id: 'modelViewer.grid.follow', defaultMessage: 'Follow the zoom' },
  navigation: { id: 'modelViewer.navigation', defaultMessage: 'Navigation' },
  navigationClose: { id: 'modelViewer.navigation.close', defaultMessage: 'Close navigation help' },
  navigationMouse: { id: 'modelViewer.navigation.mouse', defaultMessage: 'Navigation' },
  navigationKeyboard: { id: 'modelViewer.navigation.keyboard', defaultMessage: 'Keyboard' },
  navSelect: { id: 'modelViewer.navigation.select', defaultMessage: 'Select' },
  navSelectHint: {
    id: 'modelViewer.navigation.select.hint',
    defaultMessage: '(click, Shift to add, double-click for the body)',
  },
  navOrbit: { id: 'modelViewer.navigation.orbit', defaultMessage: 'Orbit' },
  navOrbitHint: { id: 'modelViewer.navigation.orbit.hint', defaultMessage: '(drag)' },
  navOrbitTouchHint: { id: 'modelViewer.navigation.orbit.touchHint', defaultMessage: '(one finger)' },
  navZoom: { id: 'modelViewer.navigation.zoom', defaultMessage: 'Zoom' },
  navZoomHint: { id: 'modelViewer.navigation.zoom.hint', defaultMessage: '(scroll)' },
  navZoomTouchHint: { id: 'modelViewer.navigation.zoom.touchHint', defaultMessage: '(pinch)' },
  navPan: { id: 'modelViewer.navigation.pan', defaultMessage: 'Pan' },
  navPanHint: { id: 'modelViewer.navigation.pan.hint', defaultMessage: '(right-drag)' },
  navPanTouchHint: { id: 'modelViewer.navigation.pan.touchHint', defaultMessage: '(two fingers)' },
  navSelectTouchHint: { id: 'modelViewer.navigation.select.touchHint', defaultMessage: '(tap)' },
  keyShading: { id: 'modelViewer.keys.shading', defaultMessage: 'Edged faces, shaded, ghosted, wireframe' },
  keyZoom: { id: 'modelViewer.keys.zoom', defaultMessage: 'Zoom in where the cursor points' },
  keyFit: { id: 'modelViewer.keys.fit', defaultMessage: 'Fit the whole part' },
  keyProjection: { id: 'modelViewer.keys.projection', defaultMessage: 'Orthographic or perspective' },
  keyMeasure: { id: 'modelViewer.keys.measure', defaultMessage: 'Measure distance' },
  keySectionSize: { id: 'modelViewer.keys.sectionSize', defaultMessage: 'Grow or shrink the section plane' },
  keyEscape: { id: 'modelViewer.keys.escape', defaultMessage: 'Close, stop the tool or clear the selection' },
  resetView: { id: 'modelViewer.view.reset', defaultMessage: 'Reset view' },
  viewOptions: { id: 'modelViewer.view.options', defaultMessage: 'View options' },
  viewPerspective: { id: 'modelViewer.view.perspective', defaultMessage: 'Perspective view' },
  viewIsometric: { id: 'modelViewer.view.isometric', defaultMessage: 'Isometric view' },
  viewFront: { id: 'modelViewer.view.front', defaultMessage: 'Front' },
  viewBack: { id: 'modelViewer.view.back', defaultMessage: 'Back' },
  viewRight: { id: 'modelViewer.view.right', defaultMessage: 'Right' },
  viewLeft: { id: 'modelViewer.view.left', defaultMessage: 'Left' },
  viewTop: { id: 'modelViewer.view.top', defaultMessage: 'Top' },
  viewBottom: { id: 'modelViewer.view.bottom', defaultMessage: 'Bottom' },
  expand: { id: 'modelViewer.expand', defaultMessage: 'Open full screen' },
  closeViewer: { id: 'modelViewer.close', defaultMessage: 'Close 3D viewer' },
  hintMouse: { id: 'modelViewer.hint.mouse', defaultMessage: 'Drag to rotate · Scroll to zoom · Right-click to pan' },
  hintTouch: { id: 'modelViewer.hint.touch', defaultMessage: 'Drag to rotate · Pinch to zoom · Two-finger pan' },
  aiRender: { id: 'modelViewer.aiRender', defaultMessage: 'AI render of this view' },
  aiModel: { id: 'modelViewer.aiRender.model', defaultMessage: 'Model' },
  aiTheme: { id: 'modelViewer.aiRender.theme', defaultMessage: 'Theme' },
  aiRenderAction: { id: 'modelViewer.aiRender.action', defaultMessage: 'Render · {credits} credits' },
  aiRenderPending: { id: 'modelViewer.aiRender.pending', defaultMessage: 'Render · – credits' },
  aiRendering: { id: 'modelViewer.aiRender.rendering', defaultMessage: 'Rendering…' },
  aiCaptureFailed: {
    id: 'modelViewer.aiRender.captureFailed',
    defaultMessage: 'This view could not be captured. Try again once the model is on screen.',
  },
  aiOfferFailed: { id: 'modelViewer.aiRender.offerFailed', defaultMessage: 'AI renders are unavailable right now.' },
  aiRenderFailed: { id: 'modelViewer.aiRender.failed', defaultMessage: 'The render could not be generated. Try again.' },
  aiResult: { id: 'modelViewer.aiRender.result', defaultMessage: 'AI render' },
  aiDownload: { id: 'modelViewer.aiRender.download', defaultMessage: 'Download' },
  aiBack: { id: 'modelViewer.aiRender.back', defaultMessage: 'Back to 3D' },
  themeStudio: { id: 'modelViewer.aiRender.theme.studio', defaultMessage: 'Studio' },
  themeMetal: { id: 'modelViewer.aiRender.theme.metal', defaultMessage: 'Machined metal' },
  themeClay: { id: 'modelViewer.aiRender.theme.clay', defaultMessage: 'Clay model' },
  themeOutdoor: { id: 'modelViewer.aiRender.theme.outdoor', defaultMessage: 'Outdoor' },
  loading: { id: 'modelViewer.loading', defaultMessage: 'Loading 3D model…' },
  empty: { id: 'modelViewer.empty', defaultMessage: 'No 3D model yet' },
  unavailable: { id: 'modelViewer.unavailable', defaultMessage: '3D view unavailable' },
  retry: { id: 'modelViewer.retry', defaultMessage: 'Retry' },
});
